import type { ResourceUsage } from '../redux/types';

export function calculatePriceForResources(enrichedResourceUsages: ResourceUsage[]): number | undefined {
    if (enrichedResourceUsages.length === 0) {
        return;
    }
    let sum = 0;
    for (const resourceUsage of enrichedResourceUsages) {
        if (resourceUsage.price === undefined) {
            return;
        }
        sum += resourceUsage.price * 100;
    }
    return Number.isNaN(sum) ? undefined : Math.round(sum) / 100;
}
